<template>
  <md-toolbar
    md-elevation="0"
    class="md-sticky md-primary"
    :class="{
      'md-toolbar-absolute md-fixed-top': $route.meta.navbarAbsolute,
    }"
  >
    <div class="md-toolbar-row">
      <div class="md-toolbar-section-start">
        <h3 class="md-title">{{ prefix }}{{ $route.name }}</h3>
      </div>
      <div class="md-toolbar-section-end">
        <slot name="content-end">
          <md-button
            class="md-just-icon md-round md-simple md-toolbar-toggle"
            :class="{ toggled: $sidebar.showSidebar }"
            @click="toggleSidebar"
          >
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </md-button>

          <div class="md-collapse">
            <h3 class="md-title">Welcome {{ $keycloak.userName }}</h3>
            <md-list>
              <md-list-item v-if="checkRoleSettingAccess()">
                <router-link to="/settings">
                  <img src="/img/wavycat/settings.svg" width="24" />
                </router-link>
              </md-list-item>
              <a href="https://drive.google.com/drive/folders/1jzkF73IolaKRf-mgZBHvcYAY-X1pJsHP" target="_blank" rel="noreferrer noopener">
                <md-list-item>
                  <img src="/img/wavycat/help.svg" width="28" />
                </md-list-item>
              </a>
              <md-list-item>
                <a :href="$keycloak.createLogoutUrl()">
                  <img src="/img/wavycat/log-out.svg" width="24" />
                </a>
              </md-list-item>
            </md-list>
          </div>
        </slot>
      </div>
    </div>
  </md-toolbar>
</template>

<script>
export default {
  props: {
    prefix: String,
  },
  methods: {
    checkRoleSettingAccess() {
      return this.$root.hasBackendRole('backoffice_read')
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize()
      }
    },
  },
}
</script>
